<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <polyline class="cls-6" points="12.51 14 12.51 63.86 12.51 76 74.52 76"/>
  <polyline class="cls-6" points="12.51 64.93 21.13 55.18 28.87 62.87 59.71 26.95 67.08 32.36 74.52 22.92"/>
  <circle class="cls-1" cx="43.52" cy="45" r="15.06"/>
  <path class="cls-2" d="m43.52,61.11c-8.88,0-16.11-7.23-16.11-16.11s7.23-16.11,16.11-16.11,16.11,7.23,16.11,16.11-7.23,16.11-16.11,16.11Zm0-30.12c-7.73,0-14.01,6.29-14.01,14.01s6.29,14.01,14.01,14.01,14.01-6.28,14.01-14.01-6.28-14.01-14.01-14.01Z"/>
  <circle class="cls-5" cx="21.08" cy="55.94" r="2.97"/>
  <circle class="cls-5" cx="28.84" cy="62.53" r="2.97"/>
  <circle class="cls-5" cx="59.89" cy="27.47" r="2.97"/>
  <circle class="cls-5" cx="66.98" cy="31.85" r="2.97"/>
  <circle class="cls-5" cx="74.52" cy="22.92" r="2.97"/>
  <g>
    <rect class="cls-4" x="43.36" y="38.33" width=".32" height="15.18"/>
    <path class="cls-4" d="m49.31,53.83h-11.6c-1.16,0-2.11-.95-2.11-2.11v-11.6c0-1.16.95-2.11,2.11-2.11h11.6c1.16,0,2.11.95,2.11,2.11v11.6c0,1.16-.95,2.11-2.11,2.11Zm-11.6-15.18c-.81,0-1.47.66-1.47,1.47v11.6c0,.81.66,1.47,1.47,1.47h11.6c.81,0,1.47-.66,1.47-1.47v-11.6c0-.81-.66-1.47-1.47-1.47h-11.6Z"/>
    <g>
      <g>
        <path class="cls-3" d="m47.88,43.31c-.06,0-.13.01-.18.05-.51.39-1.23.62-2.01.62s-1.51-.24-2.02-.63c-.04-.03-.1-.05-.15-.05v-6.92h3.95l.41,6.92Z"/>
        <path class="cls-8" d="m45.69,44.09c-.79,0-1.53-.23-2.09-.65-.02-.02-.05-.03-.09-.03h-.11v-7.13h4.15l.43,7.14h-.12s-.08,0-.11.03c-.56.42-1.29.65-2.07.65Zm-2.07-.88s.08.03.11.05c.52.39,1.22.61,1.96.61s1.43-.21,1.95-.6c.04-.03.08-.05.13-.06l-.4-6.72h-3.74v6.72Z"/>
      </g>
      <g>
        <path class="cls-3" d="m39.56,36.39l-.42,6.92c-.05,0-.11.02-.15.05-.51.39-1.23.62-2.01.62-.07,0-.13,0-.19,0-1.76-.09-2.92-1.43-2.43-2.71l.21-.56,1.52-3.98c.08-.21.33-.35.61-.35h2.85Z"/>
        <path class="cls-8" d="m36.99,44.09c-.07,0-.14,0-.2,0-1-.05-1.87-.5-2.33-1.21-.33-.51-.4-1.1-.19-1.64l1.74-4.54c.09-.25.38-.42.71-.42h2.96l-.43,7.13h-.1s-.07.02-.09.03c-.55.42-1.29.64-2.07.64Zm-.28-7.6c-.24,0-.45.11-.52.28l-1.74,4.54c-.19.48-.12,1,.17,1.45.42.65,1.23,1.06,2.17,1.11.06,0,.13,0,.19,0,.74,0,1.43-.21,1.95-.6.03-.02.07-.04.11-.06l.4-6.73h-2.74Z"/>
      </g>
      <path class="cls-7" d="m43.52,36.39v6.92c-.06,0-.11.01-.16.05-.51.39-1.23.63-2.02.63s-1.49-.24-2.01-.62c-.05-.04-.12-.06-.19-.05l.42-6.92h3.96Z"/>
      <path class="cls-7" d="m50.24,43.98c-.06,0-.13,0-.19,0-.78,0-1.49-.24-2.01-.62-.04-.03-.1-.05-.16-.05l-.41-6.92h2.87c.28,0,.52.14.59.33l1.53,3.99.22.56c.49,1.27-.67,2.62-2.43,2.7Z"/>
    </g>
    <path class="cls-4" d="m44.98,48.14c-.15,0-.26-.12-.26-.26v-1.22c0-.15.12-.26.26-.26s.26.12.26.26v1.22c0,.15-.12.26-.26.26Z"/>
    <path class="cls-4" d="m42.18,48.14c-.15,0-.26-.12-.26-.26v-1.22c0-.15.12-.26.26-.26s.26.12.26.26v1.22c0,.15-.12.26-.26.26Z"/>
    <path class="cls-4" d="m50.05,44.2c-.8,0-1.56-.24-2.14-.67-.02-.01-.06-.01-.08,0-.57.43-1.33.67-2.14.67s-1.57-.24-2.15-.68c-.01,0-.04,0-.06,0-.57.44-1.34.68-2.15.68s-1.56-.24-2.14-.67c-.02-.01-.06-.01-.08,0-.57.43-1.33.67-2.14.67-.07,0-.14,0-.2,0-1.04-.05-1.94-.52-2.42-1.25-.35-.54-.42-1.16-.2-1.74l1.74-4.54c.11-.29.44-.48.81-.48h13.63c.36,0,.68.19.79.47l1.74,4.55c.22.58.15,1.2-.2,1.74-.48.73-1.38,1.2-2.42,1.25-.07,0-.14,0-.21,0Zm-2.18-1.1c.11,0,.21.03.3.09.5.38,1.17.58,1.88.58.06,0,.12,0,.18,0,.9-.05,1.68-.44,2.08-1.06.28-.42.33-.91.16-1.35l-1.74-4.55c-.04-.1-.19-.2-.4-.2h-13.63c-.19,0-.37.09-.42.21l-1.74,4.54c-.17.45-.11.93.16,1.36.4.62,1.18,1.02,2.09,1.06.06,0,.12,0,.18,0,.71,0,1.38-.21,1.88-.58.17-.13.42-.13.59,0,.5.37,1.17.58,1.88.58s1.39-.21,1.89-.59c.16-.12.41-.12.57,0,.5.38,1.17.59,1.89.59s1.38-.21,1.88-.58c.08-.06.19-.09.3-.09Z"/>
  </g>
  <g>
    <circle class="cls-1" cx="59.63" cy="50.2" r="6.01"/>
    <path class="cls-2" d="m59.63,56.62c-3.54,0-6.43-2.88-6.43-6.43s2.88-6.43,6.43-6.43,6.43,2.88,6.43,6.43-2.88,6.43-6.43,6.43Zm0-12.01c-3.08,0-5.59,2.51-5.59,5.59s2.51,5.59,5.59,5.59,5.59-2.51,5.59-5.59-2.51-5.59-5.59-5.59Z"/>
  </g>
  <g>
    <circle class="cls-7" cx="56.58" cy="50.2" r=".96"/>
    <circle class="cls-7" cx="59.63" cy="50.2" r=".96"/>
    <circle class="cls-7" cx="62.67" cy="50.2" r=".96"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "AllMetricsWoROMAbbrIcon",
}
</script>

<style scoped>
    .cls-1 {
      fill: #fff;
    }
    .cls-2 {
      fill: #0f5b71;
    }
    .cls-3 {
      fill: #b3decd;
    }
    .cls-4 {
      fill: #115c72;
    }
    .cls-5 {
      fill: #0b5e73;
    }
    .cls-6 {
      fill: none;
      stroke: #59c5c7;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 3px;
    }
    .cls-7 {
      fill: #59c5c7;
    }
    .cls-8 {
      fill: #135d73;
    }
</style>